module.exports = __webpack_public_path__ + "static/img/Bachelor_010728.356ffa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010728.jpg
// module id = 233
// module chunks = 0